import React, { useState } from "react";
import { customerDetails } from "Stores/customerDetails";
import SettingPopup from "./SettingPopup";
import Utils from "Utils/utils";
import { makeApi, URLS } from "Utils/apiURL";
import { toasterState } from "Components/common/Toaster";

const DiscoverSettings = (props) => {
  const {
    teamData = {},
    email = "",
    teamInfo = {},
    setTeamInfo = () => {},
  } = props || {};

  const [loader, setLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const saveAction = async () => {
    if (email) {
      setLoader(true);
      try {
        let url = `${URLS.updateDataSearchSettings}?email=${email}`;
        // Merged form state (same source as popup) so list-builder fields are current
        const merged = { ...(teamInfo?.team || {}), ...teamInfo };
        const flatTeam = { ...(teamInfo?.team || {}), ...teamInfo };
        // Force list-builder fields into payload so backend always receives them
        const lbEligible = merged.lbSearchesEligible;
        flatTeam.lbSearchesEligible =
          typeof lbEligible === "number" && !Number.isNaN(lbEligible)
            ? lbEligible
            : parseInt(lbEligible, 10) || 0;
        flatTeam.listBuilderEnabled = !!merged.listBuilderEnabled;
        const config = {
          url,
          method: "POST",
          data: flatTeam,
        };
        let response = await makeApi(config);
        if (response?.data?.success) {
          const savedTeam = response?.data?.team || {};
          // Merge saved team at top level so form shows updated values (e.g. lbSearchesEligible)
          let tempObj = {
            ...teamData,
            ...savedTeam,
            team: savedTeam,
          };
          customerDetails.setCustomerDetails(tempObj);
          setTeamInfo(tempObj);
          toasterState.setToastMsg("Successfully updated", "success");
        } else {
          toasterState.setToastMsg("Failed to update", "fail");
        }
      } catch (err) {
        console.error("ERROR in updating data search settings", err);
      }
      setLoader(false);
    }
  };

  return (
    <div className="discoverSettingSection">
      <div className="actionBtn" onClick={() => setShowPopup(true)}>
        <span className="label">Update data feature flags</span>
        <i className="material-icons">arrow_forward</i>
      </div>
      {showPopup && (
        <SettingPopup
          teamInfo={teamInfo}
          loader={loader}
          setTeamInfo={setTeamInfo}
          close={() => setShowPopup(false)}
          save={saveAction}
        />
      )}
    </div>
  );
};

export default DiscoverSettings;
